import React, { useCallback } from "react";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { Col, Row, Form, Select, Button, Upload } from "antd";
import { GatePassStatus, GatePassStatusMap } from "@/utils/enum";
import { normalizeFile, fakeFileUpload } from "@/utils/form";
import { GATEPASS_MIME_TYPES } from "@/utils/gatepass";
import { Validator } from "@/utils/validator";
import SignedLink from "@/components/SignedLink";

export default function GatePassForm({ formRef, readOnly }) {
  const onGatePassChange = useCallback(
    value => {
      if (value !== GatePassStatus.Attached) {
        formRef.setFieldsValue({
          gatePassUrl: null,
        });
      }
    },
    [formRef],
  );

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24} md={24} lg={24}>
        <Form.Item name="gatePassStatus" label="Gate Pass" rules={[Validator.required("Gate Pass is required")]}>
          <Select
            placeholder="Status"
            getPopupContainer={trigger => trigger.parentElement}
            className="dealerVehicleSelectOption"
            disabled={readOnly}
            onChange={onGatePassChange}
          >
            <Select.Option value={GatePassStatus.NotRequired}>
              {GatePassStatusMap[GatePassStatus.NotRequired]}
            </Select.Option>
            <Select.Option value={GatePassStatus.Pending}>{GatePassStatusMap[GatePassStatus.Pending]}</Select.Option>
            <Select.Option value={GatePassStatus.Attached}>{GatePassStatusMap[GatePassStatus.Attached]}</Select.Option>
          </Select>
        </Form.Item>
      </Col>

      <Form.Item
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.gatePassStatus !== currentValues.gatePassStatus ||
          prevValues.gatePassUrl !== currentValues.gatePassUrl
        }
        noStyle // avoid empty space between form items
      >
        {({ getFieldValue }) => {
          const currentGatePassStatus = getFieldValue("gatePassStatus");
          const currentGatePassUrl = getFieldValue("gatePassUrl");

          return (
            <Col xs={24} sm={24} md={24} lg={24}>
              {currentGatePassStatus === GatePassStatus.Attached && !currentGatePassUrl && (
                <Form.Item
                  name="gatePassFile"
                  label="Gate Pass File"
                  valuePropName="fileList"
                  getValueFromEvent={normalizeFile}
                  rules={[Validator.required("Gate Pass file is required")]}
                  style={{
                    marginBottom: "12px",
                  }}
                >
                  <Upload
                    maxCount={1}
                    customRequest={fakeFileUpload}
                    disabled={readOnly}
                    accept={GATEPASS_MIME_TYPES.join(",")}
                  >
                    <Button>
                      <UploadOutlined /> Click to upload gate pass
                    </Button>
                  </Upload>
                </Form.Item>
              )}
              {currentGatePassStatus === GatePassStatus.Attached && currentGatePassUrl && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Form.Item name="gatePassStatus" hidden />
                  <p style={{ marginTop: "12px" }}>Gate Pass Url</p>
                  <SignedLink staticUrl={currentGatePassUrl} style={{ marginLeft: "16px", marginRight: "16px" }}>
                    <Button download type="primary">
                      View
                    </Button>
                  </SignedLink>

                  <Button
                    key="delete-address"
                    type="danger"
                    icon={<DeleteOutlined />}
                    shape="circle"
                    onClick={() => {
                      formRef.setFieldsValue({
                        gatePassStatus: GatePassStatus.NotRequired,
                        gatePassUrl: null,
                      });
                    }}
                  />
                </div>
              )}
            </Col>
          );
        }}
      </Form.Item>
      <Form.Item name="gatePassUrl" hidden />
    </Row>
  );
}
